/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetProjectItemTaskQuery } from '../../models/get-project-item-task-query';
import { GetProjectItemTaskQueryResult } from '../../models/get-project-item-task-query-result';

export interface ApiProjectItemsTasksGetProjectItemsTasksPost$Plain$Params {
      body?: GetProjectItemTaskQuery
}

export function apiProjectItemsTasksGetProjectItemsTasksPost$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectItemsTasksGetProjectItemsTasksPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectItemTaskQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectItemsTasksGetProjectItemsTasksPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetProjectItemTaskQueryResult>;
    })
  );
}

apiProjectItemsTasksGetProjectItemsTasksPost$Plain.PATH = '/api/ProjectItemsTasks/GetProjectItemsTasks';
